import '../apps/bankrate-cookie'
import '../bankrate-tracking'
import '../apps/bankrate-faux-anchor' // dynamic import possibility
import '../all-targets-blank' // good candidate to move to the WP side of the shop for article copy
import '../apps/components' // see if we can do without this, it appears to be no longer used.
import '../apps/legacy-components/eu-cookie' // determine use case since we have onetrust...
